import { useDropdownBoundaryContext } from '../../../../DropdownBoundaryContext';

export const useDropdownBoundary = () => {
  const { boundary, footerHeight, pageWrapperElement } =
    useDropdownBoundaryContext();

  return { boundary, footerHeight, pageWrapperElement };
};
